import { render, staticRenderFns } from "./ArtificialServices.vue?vue&type=template&id=517c206c&scoped=true&"
var script = {}
import style0 from "./ArtificialServices.vue?vue&type=style&index=0&id=517c206c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c206c",
  null
  
)

export default component.exports